import * as UserService from "../services/UserService";

export const getPhoneVerificationCodeHandler = async (data) => {

    const body = {
        "email": data.email,
        "phone": data.phone,
        "locale":data.locale,
    }
    const response = await UserService.createUpdatePhoneToken(body);
    return response;
}

export const updateUserProfileHandler = async (data) => {
    const body = {
        "email": data.email,
        "phone": data.phone,
        "code":data.code,
        "token":data.token,
        "firstName":data.firstName,
        "lastName": data.lastName,


    }
    const response = await UserService.updatePhoneByCodeAndToken(body);
    return response;
}


